<template>
    <v-layout row wrap>
        <v-flex xs0 sm0 md2 lg2 />
        <v-flex xs12 sm6 md4 lg4>
            <slot />
        </v-flex>
        <v-flex xs12 sm6 md4 lg4>
            <h3 class="custom_text_type_story">
                Style de la story
            </h3>
            <v-select v-model="select" :hint="select.desc ? select.desc: ''" :items="storyStyle" item-text="state"
                      item-value="desc" label="Select" persistent-hint return-object solo
                      class="custom_select_type_story" @change="changeSelectType" />
        </v-flex>
        <v-flex xs0 sm0 md2 lg2 />
        <v-flex xs12 class="full_content">
            <v-layout row wrap>
                <v-flex xs12 sm6 md7 class="custom_flex_padding_right">
                    <h3 class="custom_text_add_field">
                        Saisie des contenus
                    </h3>
                    <v-menu transition="slide-y-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn class="custom_btn_story custom_btn_add_field custom_btn_color_blue" v-on="on">
                                Ajouter un contenu
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item v-for="(item, index) in storyItem" :key="index"
                                         :disabled="item.option === 'disabled'" link @click="addComponent(index)">
                                <v-list-item-title v-text="item.name" />
                            </v-list-item>
                        </v-list>
                    </v-menu>
                    <div class="data_message">
                        Ajouter des contenus à votre story et organiser-les en effectuant du drag and drop.
                    </div>
                    <v-expansion-panels v-model="panelActive" class="custom_expansion_panel">
                        <draggable v-model="listItem" handle=".v-expansion-panel-header" @change="reopenPanel">
                            <transition-group type="transition" :name="'flip-list'">
                                <v-expansion-panel v-for="(item, index) in listItem" :key="listItem.length + index">
                                    <v-expansion-panel-header>
                                        <i class="fas fa-arrows-alt-v" />
                                        <div>{{ getComponentName(item.type) }}</div>
                                    </v-expansion-panel-header>
                                    <v-expansion-panel-content>
                                        <dynamic-input :value="item" :refresh="refresh" :index="index"
                                                       @validate="setValidData(index, $event)"
                                                       @loading="setLoadingData(index, $event)" />
                                    </v-expansion-panel-content>
                                </v-expansion-panel>
                            </transition-group>
                        </draggable>
                    </v-expansion-panels>
                    <v-layout class="publish_btn">
                        <v-flex xs6>
                            <v-text-field id="link_blinkl" v-model="blinklUrl" />
                            <v-btn class="custom_btn_add_field custom_btn_color_blue" @click="copyStoryLink">
                                Copier le lien
                            </v-btn>
                        </v-flex>
                        <v-flex xs6>
                            <v-btn class="custom_btn_add_field custom_btn_color_blue"
                                   :disabled="disabledPublish" :loading="loadingPublish"
                                   @click="updateStory">
                                Publier
                                <template v-slot:loader>
                                    <span class="custom-loader">
                                        <v-icon light>cached</v-icon>
                                    </span>
                                </template>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-flex>
                <v-flex xs12 sm6 md5 class="custom_flex_padding_left">
                    <mobile-previewer :data="{id : action._id, mode: 'story'}" :refresh="refreshMobile" />
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import draggable from 'vuedraggable';
    import { storyStyle } from './story/storyStyle';

    export default {
        name: 'Story',
        components: {
            draggable,
            MobilePreviewer: () => import('./story/MobilePreviewer'),
            DynamicInput: () => import('./story/DynamicInput')
        },
        data: () => ({
            storyItem: [
                { name: 'Texte', option: '', data: { type: 'complex_text', data: [] } },
                { name: 'Images', option: '', data: { type: 'complex_image', data: {} } },
                { name: 'Video', option: '', data: { type: 'complex_video', data: {} } },
                { name: 'Audio', option: '', data: { type: 'complex_sound', data: {} } }
            ],
            storyStyle: [{ state: '', desc: '' }],
            select: { state: '', desc: '' },
            refreshMobile: 0,
            refresh: 0,
            panelActive: undefined,
            inputsDataValidation: [],
            inputsDataUploading: []
        }),
        computed: {
            ...mapGetters('actions', ['action']),
            ...mapGetters('app', ['isMobile']),
            listItem: {
                get () {
                    return [...this.$store.state.actions.story.currentStory.listItem];
                },
                set (value) {
                    this.$store.commit('actions/story/STORY_UPDATE_LIST_ITEM', value);
                }
            },
            blinklUrl: function () {
                return window.location.origin + '/story/' + this.action._id + '/index';
            },
            getComponentName: function () {
                return (type) => {
                    for (let i = 0; i < this.storyItem.length; i++) {
                        if (this.storyItem[i].data.type === type) {
                            return this.storyItem[i].name;
                        }
                    }
                    return 'Undefined';
                };
            },
            disabledPublish: function () {
                return !this.inputsDataValidation.reduce((acc, item) => acc && item, true);
            },
            loadingPublish: function () {
                return this.inputsDataUploading.reduce((acc, item) => acc || item, false);
            }
        },
        mounted () {
            this.getStoryTypes().then((data) => {
                this.storyStyle = storyStyle.filter((x) => data.includes(x.state));
                if (this.action.action_type === 'story' && this.action.data.templateType) {
                    this.select = this.storyStyle.filter((x) => x.state === this.action.data.templateType)[0];
                }
            });
            this.inputsDataValidation = new Array(this.listItem.length).fill(true);
            this.inputsDataUploading = new Array(this.listItem.length).fill(false);
        },
        methods: {
            ...mapActions('actions/story', ['storyAddComponent', 'storyDeleteComponent']),
            ...mapActions('actions/story', ['updateStoryStyle', 'getStoryTypes', 'storyUpdate']),
            addComponent: function (index) {
                let component = JSON.parse(JSON.stringify(this.storyItem[index].data));
                if (component) {
                    let index = this.panelActive !== undefined ? this.panelActive + 1 : this.panelActive;
                    this.storyAddComponent({ component, index }).then(() => {
                        if (index !== undefined) {
                            this.inputsDataValidation.splice(index, 0, true);
                            this.inputsDataUploading.splice(index, 0, false);
                        } else {
                            this.inputsDataValidation.push(true);
                            this.inputsDataUploading.push(false);
                        }
                        this.panelActive = index !== undefined ? index : this.listItem.length - 1;
                    }).catch((err) => {
                        this.$toasted.error(err);
                    });
                }
            },
            changeSelectType: function (event) {
                this.updateStoryStyle(event.state).then(() => {
                    this.$toasted.success('Le style du story à été mis à jour');
                    this.refreshMobile++;
                }).catch((err) => {
                    this.$toasted.error(err);
                });
            },
            updateStory: function () {
                this.storyUpdate().then(() => {
                    this.$toasted.success('Changement correctement pris en compte.');
                    this.refreshMobile++;
                }).catch((err) => {
                    this.$toasted.error(err);
                });
            },
            copyStoryLink: function () {
                document.getElementById('link_blinkl').select();
                if (document.execCommand('copy')) {
                    this.$toasted.success('Vous avez copié le lien du template');
                } else {
                    this.$toasted.error('Une erreur est survenue lors de la copie');
                }
            },
            reopenPanel: function (event) {
                this.refresh++;
                if (this.panelActive > 0) {
                    this.panelActive = event.moved.newIndex;
                }
            },
            setValidData: function (index, status) {
                this.$set(this.inputsDataValidation, index, status);
            },
            setLoadingData: function (index, status) {
                this.$set(this.inputsDataUploading, index, status);
            }
        }
    };
</script>

<style lang="scss" scoped>
    .layout {
        width: 100%;
        margin: 0;
    }

    .custom_expansion_panel {
        text-align: left;
    }

    .custom_expansion_panel > div {
        width: 100%;
        margin-bottom: 20px;
    }

    #story_section .full_content {
        background-color: rgba(0, 0, 0, 0.05);
        padding: 10px 0 20px 0 !important;
        margin-top: 10px;
    }

    .custom_btn_add_field {
        margin: 0px;
        height: 48px;
    }

    .custom_text_add_field {
        margin-right: 10px;
        width: 100%;
        margin-bottom: 15px;
        text-align: center;
        margin-top: 10px;
    }

    .custom_text_add_field_p {
        line-height: normal;
        word-break: break-word;
        overflow-wrap: break-word;
        word-wrap: break-word;
        font-size: 12px;
        text-align: center;
        height: 50px;
        color: rgba(0, 0, 0, 0.54);
    }

    .custom_text_type_story {
        width: 100%;
        text-align: center;
        margin-bottom: 15px;
    }

    .custom_select_type_story {
        display: inline-block;
        margin-left: 20px;
        margin-bottom: 15px;
        width: calc(100% - 40px);
    }

    .v-btn--floating.v-btn--small .v-icon {
        font-size: 25px;
    }

    ul.v-expansion-panel {
        margin-top: 20px;
        margin-bottom: 20px;
    }

    .v-expansion-panel {
        margin-bottom: 2px;
    }

    ul.v-expansion-panel div {
        width: 100%;
    }

    .data_message {
        font-size: 12px;
        color: rgba(0, 0, 0, .54);
        margin-bottom: 8px;
        margin-top: 8px;
    }

    span li.v-expansion-panel__container {
        margin-bottom: 5px;
    }

    span li:last-child {
        margin-bottom: 0px;
    }

    .v-expansion-panel__header i {
        margin-right: 10px;
    }

    .v-btn {
        background-color: #169CEB !important;
    }

    .v-btn--active:before, .v-btn:focus:before, .v-btn:hover:before {
        background-color: #1976d2 !important;
    }

    .custom_flex_padding_right {
        padding-right: 20px !important;
    }

    .custom_flex_padding_left {
        padding-left: 20px !important;
    }

    .flip-list-move {
        transition: transform 0.5s;
    }

    .custom_btn_story {
        width: 100%;
        color: white !important;
        font-weight: 600 !important;
        text-transform: initial !important;
    }

    .publish_btn {
        position: relative;
    }

    .publish_btn button {
        width: 100%;
        color: white !important;
        font-weight: 600 !important;
        text-transform: initial !important;
    }

    .publish_btn .v-input {
        opacity: 0;
        position: absolute;
    }

    .publish_btn > div:nth-child(1) {
        margin-right: 10px;
    }

    .publish_btn > div:nth-child(2) {
        margin-left: 10px;
    }

</style>
